<template>
  <div v-if="document" class="pdf-paginator">
    <div class="pdf-paginator__pagination">
      <div class="pdf-paginator__page-input">
        <input
          ref="pageInput"
          type="number"
          v-model="pageNumberInput"
          @input="goToPageDebounced"
          @keydown.enter="goToPageImmediate"
          min="1"
          :max="document.numPages"
          class="pdf-paginator__page-input__input"
        />
      </div>
      <div class="pdf-paginator__page-indicator">
        <span>/{{ document.numPages }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DebounceMixin from '@/mixins/debounce-mixin';

export default {
  name: 'PDFPaginator',
  mixins: [DebounceMixin],
  props: {
    document: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters('currentDocument', ['currentPageNumber']),
  },
  data() {
    return {
      pageNumberInput: 1,
    };
  },
  methods: {
    goToPageDebounced() {
      this.debounce(() => {
        this.navigateToPage();
      }, 400);
    },
    goToPageImmediate() {
      this.navigateToPage();
      this.$refs.pageInput.blur();
    },
    navigateToPage() {
      let page = parseInt(this.pageNumberInput);
      if (!page) page = 1;
      page = Math.max(1, page);
      page = Math.min(this.document.numPages, page);

      this.$emit('scrollToPage', page);
    },
  },
  watch: {
    currentPageNumber() {
      this.pageNumberInput = this.currentPageNumber;
    },
  },
};
</script>

<style lang="scss">
.pdf-paginator {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;

  &__pagination {
    display: flex;
    flex-direction: row;
    gap: 4px;
    align-items: center;
  }

  &__page-input {
    display: flex;
    align-items: center;
    justify-content: center;
    background: $color-neutral-pale;
    border-radius: $border-radius-small;
    min-width: 30px;
    height: 20px;
    padding: 0 4px;
  }

  &__page-input__input {
    font-size: 12px;
    font-family: $font-families;
    min-width: 20px;
    max-width: 40px;
    width: auto;
    padding: 0;
    color: $color-normal;
    background: transparent;
    border: none;
    text-align: center;

    &:focus {
      border: none;
      outline: none;
    }
  }

  &__page-indicator {
    font-size: 12px;
    font-family: $font-families;
    color: $color-normal;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
    appearance: textfield;
    width: auto; // Override Vuetify's [type=number] { width: auto } — keep auto but with specificity
    max-width: 40px;
  }
}
</style>
